import { SimpleAnswerEnum } from '../../enums/entity.enum';
import {
  AcquisitionTypeEnum,
  AksiaCoverageGPEnum,
  CoInvStatusEnum,
  CoInvFeeStructureEnum,
  DeptSourcingEnum,
  FixedFloatingDebtEnum,
  InstrumentEnum,
  SingleAssetPortfolioEnum,
  UpfrontFeeBaseEnum,
} from '../../enums/coInvestment.enum';
import { StoreModelDate, StoreModelType } from '@aksia/infrastructure';

export class CoInvestmentDetails {
  id: number | undefined = undefined;
  fundId: number | undefined = undefined;
  projectName: string | undefined = undefined;
  companyHeadquarters: string | undefined = undefined;

  //#region Staff Involved

  sourcingAnalystName: string | undefined = undefined;
  intermediaryBroker: string | undefined = undefined;
  gpAksiaCoverage: AksiaCoverageGPEnum | undefined = undefined;

  //#endregion

  //#region Decision Dates

  status: CoInvStatusEnum | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  initialLogDate: Date | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  dateApprovedFurtherReview: Date | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  dateApprovedDD: Date | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  dateApproved: Date | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  dateNotApproved: Date | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  dateHalted: Date | undefined = undefined;

  //#endregion

  //#region Key Terms

  instrument: InstrumentEnum | undefined = undefined;
  stapledDeal: SimpleAnswerEnum | undefined = undefined;
  overview: string | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  hardCommitmentDate: Date | undefined = undefined;
  otherDatesColor: string | undefined = undefined;
  independentSponsorDeal: SimpleAnswerEnum | undefined = undefined;
  sponsorFundOfCoInvestment: string | undefined = undefined;
  transactionSummary: string | undefined = undefined;
  merits: string | undefined = undefined;
  issues: string | undefined = undefined;
  operatingExpenseCap: number | undefined = undefined;
  feeStructure: CoInvFeeStructureEnum | undefined = undefined;
  interestMargin: number | undefined = undefined;
  originalIssueDiscount: number | undefined = undefined;

  //#endregion

  //#region Management Fee

  upfrontFees: number | undefined = undefined;
  upfrontFeeBase: UpfrontFeeBaseEnum | undefined = undefined;

  //#endregion

  //#region Syndication & Capacity Notes

  totalInvestmentAmount: number | undefined = undefined;
  totalCoInvestSyndicated: number | undefined = undefined;
  indicativeCapacityAksiaClients: number | undefined = undefined;
  syndicationCapacityNotes: string | undefined = undefined;

  //#endregion

  //#region Financial Statistics

  @StoreModelType(() => StoreModelDate)
  financialsReportDate: Date | undefined = undefined;
  valuationMetric: string | undefined = undefined;
  enterpriseValue: number | undefined = undefined;
  equityValue: number | undefined = undefined;
  netDebt: number | undefined = undefined;
  revenue: number | undefined = undefined;
  ebitdanoi: number | undefined = undefined;
  evSales: number | undefined = undefined;
  evebitda: number | undefined = undefined;
  revenueCAGR: number | undefined = undefined;
  revenueCAGRTimePeriod: string | undefined = undefined;
  ebitdacagr: number | undefined = undefined;
  ebitdacagrTimePeriod: string | undefined = undefined;
  loanValue: number | undefined = undefined;
  attachmentPoint: number | undefined = undefined;
  detachmentPoint: number | undefined = undefined;

  //#endregion

  //#region Real Estate Details

  singleAssetPortfolio: SingleAssetPortfolioEnum | undefined = undefined;
  acquisitionType: AcquisitionTypeEnum | undefined = undefined;
  purchasePrice: number | undefined = undefined;
  entryCapRate: number | undefined = undefined;
  exitCapRate: number | undefined = undefined;
  fixedFloatingDebt: FixedFloatingDebtEnum | undefined = undefined;
  floatingRate: number | undefined = undefined;
  fixedRate: number | undefined = undefined;
  debtSourcing: DeptSourcingEnum | undefined = undefined;
  stabilized: SimpleAnswerEnum | undefined = undefined;
  stabilizedYOC: number | undefined = undefined;
  developReDevelop: SimpleAnswerEnum | undefined = undefined;
  sizeSF: number | undefined = undefined;
  sizeUn: number | undefined = undefined;

  //#endregion
}
